import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { Hotel_DesignPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useHotelQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(Hotel_DesignPage_Query, { variables: { hotelID } });

	return {
		data,
	};
};
